import { render, staticRenderFns } from "./input_text.vue?vue&type=template&id=c8021d68&scoped=true&"
import script from "./input_text.vue?vue&type=script&lang=js&"
export * from "./input_text.vue?vue&type=script&lang=js&"
import style0 from "./input_text.vue?vue&type=style&index=0&id=c8021d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8021d68",
  null
  
)

export default component.exports